"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkdownContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.MarkdownContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
`;
//# sourceMappingURL=styles.js.map